


























import {Component, Vue} from 'vue-property-decorator';
import {OperationsService, Vtaetigkeitschemaupdate_form, Vtaetigkeitschemaupdate_command, Vtaetigkeitschemaupdate_command_result} from "@/services/operations-service";

@Component({
})
export default class OperationsDatenbankwartung extends Vue {
    private operationsService!: OperationsService;
    
    private form_data: Vtaetigkeitschemaupdate_form | null = null;
    private command_data: Vtaetigkeitschemaupdate_command = {};
    private command_result_data: Vtaetigkeitschemaupdate_command_result | null = null;

    created() {
        this.operationsService = new OperationsService();
    }

    async mounted() {
        this.form_data = await this.operationsService.DBWartung_Vtaetigkeitschemaupdate_form();            
    }

    async execute() {
        this.command_result_data = await this.operationsService.DBWartung_Vtaetigkeitschemaupdate_command(this.command_data);
    }
}
